// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"style_lds-ellipsis__pwHva","lds-ellipsis1":"style_lds-ellipsis1__huti4","lds-ellipsis2":"style_lds-ellipsis2__nwdeu","lds-ellipsis3":"style_lds-ellipsis3__cgYRA"};